import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { findDOMNode } from "react-dom";
import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import screenfull from "screenfull";
import VideoPlayer from "../components/VideoPlayer";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";

import Duration from "../components/VideoPlayer(new)/Duration";
import { SSENSE_URL, MAIN_API } from "../config/stepoutAPI";
import ReactModal from "react-modal";
import { useChannel } from "ably/react";
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  TextField,
  InputAdornment,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import {
  ArrowBack,
  PlayArrow,
  Pause,
  Fullscreen,
  VolumeUp,
  VolumeOff,
  Timer,
  NavigateNext,
  BugReport,
  RocketLaunch,
  AccessTime,
  SportsSoccer,
  Link as LinkIcon,
  InfoOutlined,
} from "@mui/icons-material";
import { debounce, throttle } from "lodash";
import VideoTimelineEditor from "../components/VideoTimelineEditor";
import { trackEvent } from "../utils/mixpanel";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SPEEDS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75];

const VideoTabWithMs = (props) => {
  const reduxState = useSelector((state) => state);
  const timelineState = useRef();

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [matchDetails, setMatchDetails] = useState(null);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [isMute, setIsMute] = useState(false);

  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ablyMessagesEvent, setAblyMessagesEvent] = useState("");
  const [dialogBoxText, setDialogBoxText] = useState("");
  const [status, setStatus] = useState(0);
  const [showTimeline, setShowTimeline] = useState(false);
  const [showUrlInput, setShowUrlInput] = useState(false);
  const [matchVideoData, setMatchVideoData] = useState(null);

  const history = useHistory();
  const location = useLocation();
  const showDeploymentBtn = location.state?.TechQCSubmit;

  const query = useQuery();
  const match_id = query.get("match_id");
  const playerRef = useRef();

  const { channel } = useChannel(
    "analyst_portal_" + props.analystId,
    (message) => {
      if (message.name === "" || message.name === "match_analysis_event") {
        try {
          const event = JSON.parse(message.data);
          if (event?.event) handleIncomingEvent(event.event);
        } catch (err) {
          console.error("Invalid JSON in message.data", message.data);
        }
      }
    }
  );

  const handleIncomingEvent = useCallback(
    debounce((eventData) => {
      setAblyMessagesEvent({ message: eventData, isInitial: false });
    }, 100),
    []
  );

  const publishTime = throttle(() => {
    const seconds = playerRef.current?.getCurrentTime?.();
    const isPlaying = playerRef.current?.player?.isPlaying;
    if (seconds != null) {
      channel.publish(`time_update_${match_id}`, {
        timeMs: Math.round(seconds * 1000),
        playing: isPlaying,
      });
    }
  }, 100);

  useEffect(() => {
    if (isActive && status !== 9 && status !== 8 && status !== 6 && status !== 3) {
      let counter = 0;
      const intervalId = setInterval(() => {
        setTime((prevTime) => {
          const newTime = prevTime + 1;
          counter += 1;
          if (counter === 15) {
            updateTat(newTime);
            localStorage.setItem("videoTabTat", JSON.stringify({ [match_id]: newTime }));
            counter = 0;
          }
          return newTime;
        });
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [isActive, status]);

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const { seekToTime, UpdateVideoTime, SetVideoControl, videoTime, videoControl } = props;

  const updateTat = useCallback(
    async (currTime) => {
      try {
        await axios.post(`${MAIN_API}update_match_analysis_tat/`, {
          match_id: parseInt(match_id),
          analyst_id: parseInt(props.analystId),
          tat: parseInt(currTime),
        }, { headers: { Authorization: `ANALYST ${reduxState?.auth?.token}` } });
      } catch (err) { console.error(err); }
    },
    [match_id, props.analystId, reduxState.auth.token]
  );

  useEffect(() => {
    if (videoControl) { timelineState.current && timelineState.current.play(); }
    else { timelineState.current && timelineState.current.pause(); }
  }, [videoControl]);

  const getAnalysisStatus = useCallback(async () => {
    try {
      const res = await axios.post(`${MAIN_API}get_matchwise_analysis_status/`, {
        match_id: parseInt(match_id),
        analyst_id: parseInt(props.analystId),
      }, { headers: { Authorization: `ANALYST ${reduxState?.auth?.token}` } });
      setAblyMessagesEvent({ message: res.data.response_data.analysis_event_status, isInitial: true });
    } catch (err) { console.error(err); }
  }, [match_id, props.analystId, reduxState.auth.token]);

  useEffect(() => { trackEvent().track('entered_video_screen', { match_id }); }, []);
  useEffect(() => { getAnalysisStatus(); }, [getAnalysisStatus]);

  const tatMountedRef = useRef(false);
  useEffect(() => {
    if (!tatMountedRef.current) { tatMountedRef.current = true; return; }
    if (isActive) { trackEvent().track('tat_started', { match_id }); }
    else { trackEvent().track('tat_stopped', { match_id, elapsed_seconds: time }); }
  }, [isActive]);

  useEffect(() => {
    if (ablyMessagesEvent) {
      if (ablyMessagesEvent.message === "start" || ablyMessagesEvent.message === "resume") setIsActive(true);
      else setIsActive(false);

      if (ablyMessagesEvent.isInitial && (ablyMessagesEvent.message === "start" || ablyMessagesEvent.message === "resume")) setIsModalOpen(false);
      if (ablyMessagesEvent.isInitial && ablyMessagesEvent.message === "pause") { setIsModalOpen(true); setDialogBoxText("Open Analysis Keyboard to continue."); }
      else if (!ablyMessagesEvent.isInitial && ablyMessagesEvent.message === "pause") {
        updateTat(time); localStorage.setItem("videoTabTat", JSON.stringify({ [match_id]: time }));
        setIsModalOpen(true); setDialogBoxText("Match Analysis is paused from your Mobile Device. Open Analysis Keyboard to continue.");
      } else if (ablyMessagesEvent.isInitial && ablyMessagesEvent.message === null) { setDialogBoxText("Open Analysis Keyboard to continue."); }
    }
  }, [ablyMessagesEvent, match_id, time, updateTat]);

  useEffect(() => {
    let data = new FormData();
    data.append("match_id", match_id);
    data.append("analyst_id", props.analystId);
    data.append("video_timestamp", "");
    axios.post(`${SSENSE_URL}push_match_video_data/v2/`, data);
  }, [match_id, props.analystId]);

  useEffect(() => { setTimeout(() => setLoading(false), 2000); }, []);

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {});
  }

  const full = () => { if (screenfull.isEnabled) screenfull.request(findDOMNode(playerRef.current)); };

  const jumpManually = (str) => {
    const parts = str.split(":");
    if (parts.length < 3) return;
    const totalSeconds = parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
    playerRef.current.seekTo(parseFloat(totalSeconds));
    SetVideoControl(true);
    setJumpTo("");
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    if (match_id && props.all_matches) {
      const details = props.all_matches?.find((m) => m.id.toString() === match_id);
      setStatus(details?.status);
      const video = details?.youtube_videos;
      const matchVideo = video?.find((item) => item?.matches?.[0].toString() === match_id.toString());
      if (matchVideo) { matchVideo.url && setMatchVideoData(matchVideo); matchVideo.url && props.LoadVideoUrl(matchVideo.url); }
      if (details) {
        setMatchDetails(details);
        if (JSON.parse(localStorage.getItem("videoTabTat"))?.[match_id] > 0) setTime(JSON.parse(localStorage.getItem("videoTabTat"))?.[match_id]);
        else setTime(details?.analyst_tat);
      } else { setMatchDetails(null); }
    }
  }, [match_id, props.all_matches]);

  const handleSeekMouseDown = () => setSeeking(true);
  const handleSeekChange = (e) => { UpdateVideoTime(parseFloat(e)); };
  const handleSeekMouseUp = (e) => { const t = parseFloat(e); setSeeking(false); playerRef.current.seekTo(t / 1000); UpdateVideoTime(t); publishTime(); };

  useEffect(() => {
    if (typeof seekToTime === "number" && !isNaN(seekToTime)) {
      setSeeking(true); UpdateVideoTime(seekToTime); playerRef.current.seekTo(seekToTime); publishTime(); setSeeking(false);
    }
  }, [seekToTime, UpdateVideoTime]);

  const initialHandleUserKeyPress = useCallback((event) => {
    const { keyCode } = event;
    if (keyCode === 32) SetVideoControl(!videoControl);
    if (keyCode === 39) playerRef.current.seekTo(parseFloat(videoTime / 1000 + 5));
    if (keyCode === 37) playerRef.current.seekTo(parseFloat(videoTime / 1000 - 5));
  }, [SetVideoControl, videoControl, videoTime]);

  useEffect(() => {
    window.addEventListener("keydown", initialHandleUserKeyPress);
    window.addEventListener("resize", () => setLayoutWidth(window.innerWidth));
    return () => {
      window.removeEventListener("keydown", initialHandleUserKeyPress);
      window.removeEventListener("resize", () => setLayoutWidth(window.innerWidth));
    };
  }, [initialHandleUserKeyPress]);

  const isYoutubeUrl = () => {
    if (props?.videoUrl) { try { return new URL(props.videoUrl).hostname.includes("youtube.com"); } catch { return false; } }
    return false;
  };

  const gotoSubmitHandler = () => history.push(`/matchupdate/${match_id}`, { TechQCSubmit: true });

  if (loading) {
    return (
      <Box sx={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
        <Stack direction="row" alignItems="center" sx={{ px: 3, py: 1.5, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)" }}>
          <Skeleton variant="circular" width={32} height={32} sx={{ mr: 2, bgcolor: "var(--surface-2)" }} />
          <Skeleton variant="text" width={300} sx={{ bgcolor: "var(--surface-2)" }} />
        </Stack>
        <Stack direction="row" sx={{ flex: 1, p: 2, gap: 2 }}>
          <Skeleton variant="rounded" sx={{ flex: 1, borderRadius: "12px", bgcolor: "var(--surface-2)" }} />
          <Skeleton variant="rounded" width={320} sx={{ borderRadius: "12px", bgcolor: "var(--surface-2)" }} />
        </Stack>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "var(--app-bg)", overflow: "hidden" }}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        sx={{ px: { xs: 2, md: 3 }, py: 1, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", gap: 1 }}
      >
        <IconButton size="small" onClick={() => history.goBack()} sx={{ color: "var(--text-2)", borderRadius: "6px", width: 30, height: 30, "&:hover": { backgroundColor: "var(--surface-2)" } }}>
          <ArrowBack sx={{ fontSize: 16 }} />
        </IconButton>
        <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)" }}>
          #{match_id}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>
          {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
        </Typography>
        {isActive && (
          <Chip label="LIVE" size="small" sx={{ ml: "auto", height: 20, fontSize: "10px", fontWeight: 700, backgroundColor: "#10B98120", color: "#10B981", animation: "pulse 2s infinite", "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.5 } } }} />
        )}
      </Stack>

      {/* Paused Modal */}
      <Dialog open={isModalOpen} PaperProps={{ sx: { borderRadius: "12px", minWidth: 380, border: "1px solid var(--border-1)" } }}>
        <DialogTitle sx={{ backgroundColor: "rgba(232, 108, 0, 0.08)", borderBottom: "2px solid rgba(232, 108, 0, 1)", py: 1.5 }}>
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(185, 80, 0, 1)" }}>Analysis Paused</Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 2 }}>
          <Typography sx={{ fontSize: "13px", color: "var(--text-2)", mt: 1 }}>{dialogBoxText}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button variant="outlined" size="small" onClick={getAnalysisStatus} sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", borderColor: "var(--border-1)", color: "var(--text-2)" }}>Refresh</Button>
          <Button variant="contained" size="small" onClick={() => setIsModalOpen(false)} sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Main Content */}
      <Stack direction={{ xs: "column", md: "row" }} sx={{ flex: 1, p: { xs: 1, md: 2 }, gap: 2, overflow: "auto" }}>
        {/* Left: Video */}
        <Stack sx={{ flex: 1, minWidth: 0, gap: 1.5 }}>
          {/* Video Player */}
          <Box sx={{ borderRadius: "12px", overflow: "hidden", border: "1px solid var(--border-1)", backgroundColor: "#000", position: "relative" }}>
            {showUrlInput && (
              <Stack direction="row" alignItems="center" sx={{ position: "absolute", inset: 0, zIndex: 5, backgroundColor: "rgba(0,0,0,0.9)", px: 3, gap: 1.5 }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#fff", whiteSpace: "nowrap" }}>Custom URL</Typography>
                <TextField size="small" fullWidth placeholder="Paste video URL" value={url} onChange={(e) => setUrl(e.target.value)}
                  InputProps={{ sx: { borderRadius: "8px", fontSize: "13px", backgroundColor: "rgba(255,255,255,0.1)", color: "#fff", "& fieldset": { borderColor: "rgba(255,255,255,0.2)" } } }}
                />
                <Button variant="contained" size="small" onClick={() => { props.LoadVideoUrl(url); setShowUrlInput(false); setReady(true); }}
                  sx={{ textTransform: "none", borderRadius: "8px", fontSize: "12px", backgroundColor: "rgba(232, 108, 0, 1)", whiteSpace: "nowrap" }}>Load</Button>
                <IconButton size="small" onClick={() => setShowUrlInput(false)} sx={{ color: "rgba(255,255,255,0.6)" }}>
                  <ArrowBack sx={{ fontSize: 16 }} />
                </IconButton>
              </Stack>
            )}
            <VideoPlayer
              cref={playerRef} url={props.videoUrl} controls={false} played={props.videoTime} muted={isMute}
              onProgress={(e) => { !seeking && timelineState.current && timelineState.current.setTime(e / 1000); !seeking && UpdateVideoTime(e); !seeking && publishTime(); }}
              playing={props.videoControl}
              onPause={() => { timelineState.current && timelineState.current.pause(); SetVideoControl(false); }}
              onEnded={() => { timelineState.current && timelineState.current.pause(); SetVideoControl(false); }}
              onPlay={() => SetVideoControl(true)}
              onReady={() => setReady(true)}
              playbackRate={speed}
              onDuration={(t) => setDuration(t)}
            />
          </Box>

          {/* Timeline */}
          {showTimeline && ready && !isYoutubeUrl() && (
            <VideoTimelineEditor matchId={match_id} analystId={props.analystId} setShowTimeline={setShowTimeline} showTimeline={showTimeline}
              durationMs={duration * 1000} videoTimeMs={videoTime} isPlaying={videoControl}
              setTime={(e) => { UpdateVideoTime(e); playerRef.current.seekTo(e / 1000); }}
              timelineState={timelineState}
            />
          )}

          {/* Controls Bar */}
          {ready && !isYoutubeUrl() && (
            <Stack sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", overflow: "hidden" }}>
              {/* Seekbar */}
              <Stack direction="row" alignItems="center" sx={{ px: 1.5, pt: 1 }}>
                <input
                  type="range" value={props.videoTime} style={{ width: "100%", accentColor: "rgba(232, 108, 0, 1)" }}
                  min={0} max={duration * 1000} step={10}
                  onMouseDown={handleSeekMouseDown} onChange={(e) => handleSeekChange(e.target.value)} onMouseUp={(e) => handleSeekMouseUp(e.target.value)}
                />
              </Stack>

              {/* Controls row */}
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1, gap: 1 }}>
                {/* Left: Jump + Timestamp */}
                <Stack direction="row" alignItems="center" gap={1}>
                  <TextField
                    size="small" placeholder="HH:MM:SS" value={jumpTo} onChange={(e) => setJumpTo(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && jumpManually(jumpTo)}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><Timer sx={{ fontSize: 16, color: "var(--text-2)" }} /></InputAdornment>,
                      sx: { borderRadius: "8px", fontSize: "12px", width: "130px", height: 34, backgroundColor: "var(--surface-2)", "& fieldset": { borderColor: "var(--border-1)" } },
                    }}
                  />
                  <IconButton size="small" disabled={!jumpTo} onClick={() => jumpManually(jumpTo)}
                    sx={{ width: 30, height: 30, borderRadius: "6px", border: "1px solid var(--border-1)", color: "var(--text-2)" }}>
                    <NavigateNext sx={{ fontSize: 16 }} />
                  </IconButton>
                  <Chip label={<Duration milliseconds={props.videoTime} />} size="small"
                    sx={{ height: 28, fontSize: "12px", fontWeight: 600, fontFamily: "monospace", backgroundColor: "var(--surface-2)", color: "var(--text-1)", border: "1px solid var(--border-1)" }} />
                </Stack>

                {/* Center: Play/Pause */}
                <Button
                  variant="contained" onClick={() => SetVideoControl(!videoControl)}
                  startIcon={videoControl ? <Pause sx={{ fontSize: "18px !important" }} /> : <PlayArrow sx={{ fontSize: "18px !important" }} />}
                  sx={{ borderRadius: "10px", textTransform: "none", fontSize: "13px", fontWeight: 700, px: 4, height: 40, backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } }}
                >
                  {videoControl ? "Pause" : "Play"}
                </Button>

                {/* Right: Speed + Icons */}
                <Stack direction="row" alignItems="center" gap={0.5}>
                  {SPEEDS.map((s) => (
                    <Box key={s} onClick={() => setSpeed(s)}
                      sx={{
                        width: 34, height: 28, borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                        backgroundColor: speed === s ? "rgba(232, 108, 0, 1)" : "var(--surface-2)", border: speed === s ? "none" : "1px solid var(--border-1)",
                        "&:hover": { backgroundColor: speed === s ? "rgba(232, 108, 0, 1)" : "var(--surface-2)" },
                      }}
                    >
                      <Typography sx={{ fontSize: "10px", fontWeight: 600, color: speed === s ? "#fff" : "var(--text-2)" }}>{s}x</Typography>
                    </Box>
                  ))}
                  <IconButton size="small" onClick={full} sx={{ width: 28, height: 28, borderRadius: "6px", ml: 0.5, color: "var(--text-2)", "&:hover": { backgroundColor: "var(--surface-2)" } }}>
                    <Fullscreen sx={{ fontSize: 18 }} />
                  </IconButton>
                  <IconButton size="small" onClick={() => setIsMute(!isMute)} sx={{ width: 28, height: 28, borderRadius: "6px", color: "var(--text-2)", "&:hover": { backgroundColor: "var(--surface-2)" } }}>
                    {isMute ? <VolumeOff sx={{ fontSize: 18 }} /> : <VolumeUp sx={{ fontSize: 18 }} />}
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
          )}

          {/* Bottom bar: URL + Timeline toggle */}
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "10px", px: 2, py: 1 }}>
            <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <LinkIcon sx={{ fontSize: 16, color: "var(--text-2)", flexShrink: 0 }} />
              <Typography sx={{ fontSize: "12px", color: "var(--text-2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {props.videoUrl || "No video loaded"}
              </Typography>
            </Stack>
            {/* <Stack direction="row" gap={1}>
              <Button size="small" onClick={() => setShowUrlInput(true)} sx={{ textTransform: "none", fontSize: "11px", color: "var(--text-2)", borderRadius: "6px" }}>Load URL</Button>
              {ready && !isYoutubeUrl() && (
                <Button size="small" variant={showTimeline ? "contained" : "outlined"} onClick={() => setShowTimeline(!showTimeline)}
                  sx={{ textTransform: "none", fontSize: "11px", borderRadius: "6px", ...(showTimeline ? { backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } } : { borderColor: "var(--border-1)", color: "var(--text-2)" }) }}>
                  Timeline
                </Button>
              )}
            </Stack> */}
          </Stack>
        </Stack>

        {/* Right Sidebar */}
        <Stack sx={{ width: { xs: "100%", md: "320px" }, minWidth: "280px", gap: 2 }}>
          {/* Match Details Card */}
          <Stack sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", overflow: "hidden" }}>
            <Stack sx={{ px: 2, py: 1.5, backgroundColor: "var(--surface-2)", borderBottom: "1px solid var(--border-1)" }}>
              <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)" }}>Match Details</Typography>
            </Stack>
            <Stack sx={{ p: 2, gap: 1.5 }}>
              <Stack>
                <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "var(--text-1)" }}>
                  {match_id} {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
                </Typography>
                <Typography sx={{ fontSize: "11px", color: "var(--text-2)" }}>
                  {matchDetails?.tournament_name}
                </Typography>
              </Stack>

              <Stack direction="row" justifyContent="space-between" sx={{ px: 1.5, py: 1, borderRadius: "8px", backgroundColor: "var(--surface-2)" }}>
                <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>Analyst</Typography>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-1)" }}>{matchDetails?.analyst_details?.[0]?.name || "—"}</Typography>
              </Stack>

              <Stack direction="row" justifyContent="space-between" sx={{ px: 1.5, py: 1, borderRadius: "8px", backgroundColor: "var(--surface-2)" }}>
                <Typography sx={{ fontSize: "12px", color: "var(--text-2)" }}>Game Time</Typography>
                <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-1)" }}>{matchDetails?.game_time ? `${matchDetails.game_time} min` : "—"}</Typography>
              </Stack>

              {/* Teams */}
              <Stack direction="row" gap={1}>
                <Stack sx={{ flex: 1, px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600 }}>Team A</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", textAlign: "center" }}>{matchDetails?.team_a_details?.name || "—"}</Typography>
                </Stack>
                <Stack sx={{ flex: 1, px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", alignItems: "center" }}>
                  <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600 }}>Team B</Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", textAlign: "center" }}>{matchDetails?.team_b_details?.name || "—"}</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          {/* Elapsed Time Card */}
          <Stack direction="row" alignItems="center" gap={2} sx={{ backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", px: 2, py: 1.5 }}>
            <Box sx={{ px: 1.5, py: 1, borderRadius: "8px", border: "1px solid var(--border-1)", backgroundColor: isActive ? "rgba(232, 108, 0, 0.08)" : "var(--surface-2)" }}>
              <Typography sx={{ fontSize: "20px", fontWeight: 700, fontFamily: "monospace", color: isActive ? "rgba(232, 108, 0, 1)" : "var(--text-1)", lineHeight: 1 }}>
                {formatTimeFromSeconds(time)}
              </Typography>
            </Box>
            <Stack>
              <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "var(--text-1)" }}>Elapsed Time</Typography>
              <Typography sx={{ fontSize: "11px", color: "var(--text-2)" }}>Analysis duration</Typography>
            </Stack>
          </Stack>

          {/* Action Buttons */}
          <Stack gap={1}>
            <Button
              fullWidth variant="outlined"
              onClick={() => history.push(`/match-details/${match_id}`)}
              startIcon={<InfoOutlined sx={{ fontSize: "18px !important" }} />}
              sx={{
                borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 600, py: 1.25,
                borderColor: "var(--border-1)", color: "var(--text-1)",
                "&:hover": { borderColor: "var(--text-2)", backgroundColor: "var(--surface-2)" },
              }}
            >
              Details
            </Button>
            <Button
              fullWidth variant="contained" onClick={() => history.push(`/techQCMS/${match_id}`)}
              startIcon={<BugReport sx={{ fontSize: "18px !important" }} />}
              endIcon={<NavigateNext sx={{ fontSize: "18px !important" }} />}
              sx={{ borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, py: 1.25, backgroundColor: "rgba(232, 108, 0, 1)", "&:hover": { backgroundColor: "rgba(200, 93, 0, 1)" } }}
            >
              Next Step
            </Button>
            {showDeploymentBtn && (
              <Button
                fullWidth variant="contained" onClick={gotoSubmitHandler}
                startIcon={<RocketLaunch sx={{ fontSize: "18px !important" }} />}
                endIcon={<NavigateNext sx={{ fontSize: "18px !important" }} />}
                sx={{ borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, py: 1.25, backgroundColor: "#059669", "&:hover": { backgroundColor: "#047857" } }}
              >
                Proceed to Deployment
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  videoControl: state.control.videoControl,
  videoUrl: state.control.videoUrl,
  videoTime: state.control.videoTime,
  all_matches: state.match.all_matches,
  currentAction: state.control.currentAction,
  analysedString: state.control.analysedString,
  actionLog: state.control.actionLog,
  seekToTime: state.control.seekToTime,
  analystId: state.auth.analyst_id,
});

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  ClearSeekFlag,
  SetControllerToggle,
})(VideoTabWithMs);
